/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TOTPVerifyAttestationData } from './TOTPVerifyAttestationData';
import {
    TOTPVerifyAttestationDataFromJSON,
    TOTPVerifyAttestationDataFromJSONTyped,
    TOTPVerifyAttestationDataToJSON,
} from './TOTPVerifyAttestationData';

/**
 * 
 * @export
 * @interface TOTPVerifyAttestationAllOf
 */
export interface TOTPVerifyAttestationAllOf {
    /**
     * 
     * @type {TOTPVerifyAttestationData}
     * @memberof TOTPVerifyAttestationAllOf
     */
    data?: TOTPVerifyAttestationData;
}

/**
 * Check if a given object implements the TOTPVerifyAttestationAllOf interface.
 */
export function instanceOfTOTPVerifyAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TOTPVerifyAttestationAllOfFromJSON(json: any): TOTPVerifyAttestationAllOf {
    return TOTPVerifyAttestationAllOfFromJSONTyped(json, false);
}

export function TOTPVerifyAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : TOTPVerifyAttestationDataFromJSON(json['data']),
    };
}

export function TOTPVerifyAttestationAllOfToJSON(value?: TOTPVerifyAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TOTPVerifyAttestationDataToJSON(value.data),
    };
}

